import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

/** Supplies the signed-in user's organisation to a routed component's `organisationId` input via
 * `withComponentInputBinding()`. Routes using this must be guarded by something that already
 * guarantees an organisation — `practiceCoursesGuard`, for instance — since a user without one
 * cannot be served a meaningful organisation-scoped page. */
export const organisationIdResolver: ResolveFn<number | null> = () => inject(AuthService).currentUser()?.organisationId ?? null;
